import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from 'src/app/globals';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { PortalUserDtoResponse } from 'src/app/models/portalUserDto';
import { EditUserPortal } from '../models/editUserPortal';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  constructor(private http:HttpClient,private backhttp:HttpBackend) { this.httpClientBack = new HttpClient(backhttp);}
  private httpClientBack: HttpClient;

  GetProfileData():Observable<PortalUserDtoResponse>{
    return this.http.get<any>(Globals.Url + 'PortalUserUnified/Get')
  }

  UpdateProfileData(body:EditUserPortal):Observable<any>{
    return this.http.put<any>(Globals.Url + 'PortalUserUnified/Update',JSON.stringify(body))
  }
  GetAttachmentData():Observable<any>{
    return this.http.get<any>(Globals.Url + 'PortalUserUnified/GetAllAttachments?16999')
    .pipe(
      map(x=> x.result.items)
    )
  }

  UploadAttach(file:File):Observable<any>{
  
    let fileData: FormData = new FormData();
    fileData.append('file', file, file.name);
    return this.httpClientBack.post<any>(Globals.Url + 'PortalUserUnified/UploadAttach',fileData)
  }
}
